import Swiper from "swiper/bundle";
import { Autoplay } from "swiper/modules";

const teamSlide = () => {
	const x = 15;
	const y = 0;
	const t = 10;
	const swiper = new Swiper(".swiper", {
		effect: "creative",
		grabCursor: true,
		loop: true,
		speed: 300,
		autoplay: true,
		allowSlidePrev: true,

		creativeEffect: {
			limitProgress: 8,

			prev: {
				translate: ["-" + x + "%", "-" + y + "%", -1],
				scale: 0.95,
				origin: "left center",
			},

			next: {
				translate: ["200%", "5%", 0],
			},
		},
		on: {
			init: (swp) => {
				for (let s = 0; s < swp.slides.length; s++) {
					const sld = swp.slides[s];
					if(!sld.children[0]) continue;
					sld.children[0].style.transform =
						"translateY(" +
						Math.floor(Math.random() * t) +
						"%) rotate(" +
						Math.floor(Math.random() * t - t) +
						"deg)";
				}
			},
		},
	});
};

export { teamSlide };
